module.exports = __webpack_public_path__ + "img/new-zealand-logo-icon.edb303c5.png";